import type { NextPageWithLayout } from '@/pages/_app';
import { type ComponentType } from 'react';

/**
 * Higher-Order Component that wraps a page component with its layout
 * if it has a getLayout function defined.
 */
export function withLayout(module: { default: NextPageWithLayout }): { default: ComponentType } {
    const PageComponent = module.default;

    // If the page doesn't have getLayout, return it as-is
    if (!PageComponent.getLayout) {
        return module;
    }

    // Store getLayout after null check - we know it exists here
    const getLayout = PageComponent.getLayout;

    // Create a wrapped component that applies the layout
    const PageWithLayoutWrapper = () => {
        const page = <PageComponent />;
        return <>{getLayout(page)}</>;
    };

    return { default: PageWithLayoutWrapper };
}
